import { IonCol, IonContent, IonGrid, IonPage, IonRow, IonText, IonLabel, IonInput, IonTextarea, IonButton } from "@ionic/react";
import { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router";
import Footer from "../../components/Footer";
import { OptionPages } from '../../models/apiModels';
import { translation } from "../../models/translation";
import { fetchOptions } from "../../services/options_service";
import { User } from "../../models/data";
import Meta from "../../components/Meta";

interface GiftCardHomeProps {
    user: User | null;
}

const GiftCardHome: React.FC<GiftCardHomeProps> = ({ user }) => {


    const siteText = translation();
    const location = useLocation();
    const pathName = location.pathname;
    const history = useHistory();

    const isAccountPage = () => {
        if (pathName.indexOf('account') < 0) return false;
        return true
    }


    const [siteOptions, setSiteOptions] = useState<OptionPages>();

    const getOptions = async () => {
        let resp: any = await fetchOptions();
        if (!resp.error) {
            let options: OptionPages = resp.message;
            setSiteOptions(options);
        }
    }
    useEffect(() => {
        getOptions()
    }, []);

    const startGifting = (e: any) => {
        e.preventDefault();
        let data = {
            gifting: true,
            name: e.target.name.value,
            fName: e.target.fName.value,
            email: e.target.email.value,
            message: e.target.message.value
        }
        history.push(`${siteText.lan}/account/donate_gift/`, data);
        e.target.reset();
    }

    return (
        <IonPage className="pageContent">
            {siteText.lan === '/en' && <Meta url={window.location.href} description={`${siteOptions?.acf.gc_seo_title_en}`} title={`${siteOptions?.acf.gc_seo_title_en}`} shareImage={`${siteOptions?.acf.giftcard_image}`}></Meta>}
            {siteText.lan === '/fr' && <Meta url={window.location.href} description={`${siteOptions?.acf.gc_seo_title_fr}`} title={`${siteOptions?.acf.gc_seo_title_fr}`} shareImage={`${siteOptions?.acf.giftcard_image}`}></Meta>}
            {siteText.lan === '/de' && <Meta url={window.location.href} description={`${siteOptions?.acf.gc_seo_title_de}`} title={`${siteOptions?.acf.gc_seo_title_de}`} shareImage={`${siteOptions?.acf.giftcard_image}`}></Meta>}
            <IonContent>
                <IonGrid className={!isAccountPage() ? 'sw_mb_md' : ''}>
                    <IonRow className="headerImageOnly" style={{ backgroundImage: `url(${siteOptions?.acf.giftcard_image})` }}>

                    </IonRow>
                    <IonRow>
                        {siteOptions &&
                            <IonCol className="ion-text-center" offsetSm="1" offsetMd="2" sizeSm="10" sizeMd="8" >
                                <h1>{siteText.giftCardTitle}</h1>
                                {siteText.lan === '/en' && <div dangerouslySetInnerHTML={{ __html: siteOptions?.acf.gcard_heading_english! }}></div>}
                                {siteText.lan === '/fr' && <div dangerouslySetInnerHTML={{ __html: siteOptions?.acf.gcard_heading_french! }}></div>}
                                {siteText.lan === '/de' && <div dangerouslySetInnerHTML={{ __html: siteOptions?.acf.gcard_heading_german! }}></div>}
                            </IonCol>
                        }
                    </IonRow>
                    <IonRow>
                        <IonCol offsetSm="1" offsetMd="2" sizeSm="10" sizeMd="8">
                            <form onSubmit={startGifting}>
                                <IonLabel>{siteText.giftCardBeneficiaryInfoLabel}</IonLabel>
                                <IonInput name="name" required className="ion-margin-top ion-margin-bottom" disabled={!user} placeholder={siteText.giftCardBeneficiaryNamePlaceholder}></IonInput>
                                <IonInput name="fName" required className="ion-margin-bottom" disabled={!user} placeholder={siteText.giftCardBeneficiaryFirstNamePlaceholder}></IonInput>
                                <IonInput name="email" type="email" required className="ion-margin-bottom" disabled={!user} placeholder={siteText.giftCardBeneficiaryEmailPlaceholder}></IonInput>

                                <IonLabel>{siteText.giftCardMessageLabel}</IonLabel>
                                <IonTextarea name="message" placeholder={siteText.giftCardMessagePlaceholder}></IonTextarea>
                                {!user &&
                                    <div>
                                        <IonButton routerLink={`${siteText.lan}/signup`} color="primary"><IonText color="light">{siteText.giftCardSignUpButton}</IonText></IonButton>
                                        <IonButton routerLink={`${siteText.lan}/signin`} color="secondary"><IonText color="light">{siteText.giftCardSignInButton}</IonText></IonButton>
                                    </div>
                                }
                                {user && <IonButton color="primary" type="submit"><IonText color="light">{siteText.giftCardDonateButton}</IonText> </IonButton>}
                            </form>
                        </IonCol>

                    </IonRow>

                </IonGrid>
                <Footer></Footer>
            </IonContent>
        </IonPage >)
}

export default GiftCardHome;

